import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <div className="footer">
      <div className="footer-left">
        &copy; 2025, Digital Binary Labs
      </div>
      <div className="footer-right">
        v1.0.0-beta
      </div>
    </div>
  );
};

export default Footer;
